const commonTranslation = {
  hello: "Hallo",
  welcome: "Willkommen",
  english: "Englisch",
  german: "Deutsch",
  italian: "Italienisch",
  french: "Französisch",
  currentLanguage: "de-DE",
  notAvailable: "k. A.",
  close: "Schließen",
  preview: "Vorschau",
  invoiceDocument: "Rechnungsdokument",
  zoomIn: "Vergrößern",
  zoomOut: "Verkleinern",
  rotateRight: "Nach rechts drehen",
  rotateLeft: "Nach links drehen",
  resetZoom: "Zoom zurücksetzen",
  previousPage: "Vorherige Seite",
  nextPage: "Nächste Seite",
  showPassword: "Passwort anzeigen",
  hidePassword: "Passwort ausblenden",
  qrCode: "QR-Code",
  drag: "Zum Neuordnen ziehen",
  clickToRefresh: "Zum Aktualisieren klicken",
  sampleComponent: "Beispielkomponente",
  sidebar: "Seitenleiste",
  invalidCredentials: "Ungültige Anmeldedaten",
  requestFailed: "Die Anfrage konnte nicht ausgeführt werden",
  toast_error: "Fehler",
  toast_warning: "Warnung",
  toast_success: "Erfolg",
  toast_info: "Information",
  unknownStatus: "Unbekannter Status",
  unknownLanguage: "Unbekannte Sprache",
  unknownField: "Zusätzliche Informationen"
};

const loginComponent = {
  email: "E-Mail",
  emailAddress: "E-Mail Adresse",
  username: "Benutzername",
  password: "Passwort",
  login: "Anmelden",
  signUp: "Registrieren",
  multifactorAuthentication: "Mehrfaktorauthentifizierung",
  OTPCode: "OTP-Code",
  verifyAndProceed: "Verifizieren & Fortfahren",
  resendOTP: "OTP erneut senden",
  readMore: "Mehr Info",
  logout: "Abmelden",
  loginOrSignup: "Anmelden",
  loginWelcome: "Willkommen zurück! Bitte geben Sie Ihre Daten ein.",
  enterEmail: "Geben sie ihre E-Mail Adresse ein",
  enterPassword: "Passwort",
  getStarted: "Loslegen!",
  verificationRequired: "Verifizierung erforderlich",
  verificationDescription: "Geben Sie den Code ein, der in Ihrer Authentifizierungs-App angezeigt wird",
  loginRemember: "24 Stunden lang angemeldet bleiben",
  ForgotPassword: "Passwort vergessen",
  NoAccount: "Sie haben noch kein Konto?",
  loginAppInfo: "Ich habe keinen Zugriff auf meine Authenticator-App",
  loginSuccess: "Anmeldung erfolgreich",
  loginError: "Anmeldefehler",
  loginHeroTitle: "Willkommen bei IDP-AI von UpQuAI",
  loginHeroSubtitle: "Wo Technologie auf Versicherungsexpertise trifft",
};

const dashboardComponent = {
  gridView: "Rasteransicht",
  tableView: "Tabellenansicht",
  PDFExtraction: "Schadeneingang",
  search: "Suche",
  filter: "Filter",
  filters: "Filter",
  sortBy: "Sortieren",
  refresh: "Aktualisieren",
  sort: "Sortieren",
  sortFields: "Sortierfelder",
  edit: "Bearbeiten",
  download: "Herunterladen",
  versionHistory: 'Verlauf',
  documentName: "Dokumentname",
  operator: "Bearbeiter",
  receiverName :  "Empfängername",
  receiver: "Empfänger",
  extractedAt: "Extrahiert am",
  claimAge: "Alter",
  claimAgeLegendTitle: "Schadenalter vs. Durchschnitt",
  claimAgeLegendBody:
    "Die Farbe zeigt die Zeit seit der Extraktion relativ zum Durchschnitt der aktuell sichtbaren Schaden. Grün = neuer, Rot = älter.",
  claimAgeAvgBaseline: "Durchschnitt der Ansicht: {{age}}",
  claimAgeNewerThanAvg: "{{ratio}}× jünger als der Durchschnitt",
  claimAgeOlderThanAvg: "{{ratio}}× älter als der Durchschnitt",
  claimAgeAboutAvg: "Ungefähr Durchschnittsalter",
  claimAgeAverageMark: "Durchschnitt",
  claimAgeTier_fresh: "Frisch",
  claimAgeTier_typical: "Typisch",
  claimAgeTier_aging: "Alternd",
  claimAgeTier_stale: "Überfällig",
  lastModified: "Zuletzt geändert",
  asc: "Auf",
  desc: "Ab",
  noOfPages: "Seitenanzahl",
  status: "Status",
  action: "Aktion",
  details: "Einzelheiten",
  medicine_info: "Informationen zu Arzneimitteln",
  generalInformation: "Allgemeine Informationen",
  invoice: "Rechnung",
  invoiceDate: "Rechnungsdatum",
  invoiceReference: "Rechnungsreferenz",
  vetName: "Tierarztname",
  vetStreet: "Tierarztstrasse",
  city: "Stadt",
  postalCode: "Postleitzahl",
  language: "Sprache",
  policyholderName: "Name des Versicherungsnehmers",
  policyholderAddress: "Straße des Versicherungsnehmers",
  treatment: "Behandlung",
  treatmentDate: "Behandlungsdatum",
  diagnosis: "Diagnose",
  itemName: "Artikelname",
  quantity: "Menge",
  prize: "Preis",
  VAT: "MwSt.",
  addTreatment: "Behandlung hinzufügen",
  addItem: "Artikel hinzufügen",
  total: "Gesamt",
  subTotal: "Zwischensumme",
  calculatedSum: "Gesamtsumme nach Rabatt",
  notes: "Notizen",
  page: "Seite",
  pages: "Seiten",
  min: " Min",
  mins: " Min.",
  hour: " Stunde",
  hours: " Stunden",
  day: " Tag",
  days: " Tagen",
  month: " Monat",
  months: " Monate",
  ago: "vor",
  timeAgoPhrase: "vor {{count}} {{unit}}",
  modifiedBy: "Geändert von",
  modifiedAt: "Geändert am",
  clickASC: "Klicken, um aufsteigend zu sortieren",
  clickDESC: "Klicken, um absteigend zu sortieren",
  petName: "Haustiername",
  treatmentName: "Behandlungsname",
  items: "Artikel",
  InvoiceTotalSumPriceWithoutVAT: "Rechnungsgesamtbetrag ohne Mehrwertsteuer",
  InvoiceTotalSumPriceWithVAT: "Rechnungsgesamtbetrag mit Mehrwertsteuer",
  CalculatedTotalSum: "Berechnete Gesamtsumme",
  TotalDiscountAmount: "Gesamtrabattbetrag",
  CalculatedTotalSumAfterDiscount: "Berechnete Gesamtsumme nach Rabatt",
  recent: "Jüngste",
  viewHistory: "Siehe Verlauf",
  remember: "Fragen Sie heute nicht noch einmal",
  assignment_confirmation: "Zuweisung bestätigen",
  revoke_confirmation:"Zuweisung aufheben",
  rememberSentance: 'Wir werden Sie heute nicht mehr nach einem Bestätigungscode auf Ihrem vertrauenswürdigen Gerät fragen, wenn Sie sich anmelden.',
  Complete_login: "Anmeldung abschliessen",
  date: "Datum",
  time: "Zeit",
  note: "Notiz",
  comment: "Kommentare",
  profile: "Profil",
  no_content: "Kein Inhalt",
  revoke: "Widerrufen",
  deleteTreatment:"Behandlung löschen",
  deleteItem:"Element löschen",
  lastUpdate:"Letztes Update",
  board:"Kacheln",
  table:"Liste",
  modified:"Angepasst von",
  showing:"Anzeigen",
  totalSum:"Gesamtsumme",
  of: "von",
  none: "Keine",
  customVAT: "MwSt eingeben",
  quality_level: "Qualitätsstufe",
  good: "Gut",
  verify: "Überprüfen",
  not_extracted: "Nicht Extrahiert",
  apply: "Anwenden",
  kpiTotal: "Total",
  kpiNotStarted: "Nicht begonnen",
  kpiInProgress: "In Bearbeitung",
  kpiCompleted: "Abgeschlossen",
  kpiNeedsVerification: "Zu überprüfen",
  kpiFailed: "Fehlgeschlagen",
  archive: "Archivieren",
  reprocess: "Erneut verarbeiten",
  archiveConfirmTitle: "Dokument archivieren",
  archiveConfirmContent: "Dieses Dokument archivieren? Es verschwindet aus der Warteschlange, bleibt aber im Verlauf.",
  reprocessConfirmTitle: "Dokument erneut verarbeiten",
  reprocessConfirmContent: "Dieses Dokument erneut durch die Extraktion schicken? Aktuelle Daten werden ersetzt.",
  failureReason: "Fehlerursache",
  receivedFrom: "Empfangen von",
  receivedAt: "Empfangen am",
  documentPreview: "Dokumentvorschau",
  failure_invalid_file_format: "Ungültiges Dateiformat — die Datei konnte nicht gelesen werden.",
  failure_invalid_pet_invoice: "Keine gültige Tierarztrechnung — keine Rechnungsdaten erkannt.",
  failure_extraction_issue: "Extraktionsfehler — die Verarbeitung ist unerwartet fehlgeschlagen.",
  documentArchived: "Dokument archiviert",
  documentReprocessing: "Dokument zur erneuten Verarbeitung gesendet",
  archiveError: "Dokument konnte nicht archiviert werden",
  reprocessError: "Dokument konnte nicht erneut verarbeitet werden",
  countsError: "Zähler konnten nicht geladen werden",
  viewDetails: "Details anzeigen",
  dateFrom: "Von",
  dateTo: "Bis",
  dateRange: "Zeitraum",
  searchPlaceholderExtended: "Datei, Versicherungsnehmer, Tierarzt, Rechnungsnr. suchen",
  noteBy: "von",
  addNote: "Notiz hinzufügen",
  writeNote: "Notiz schreiben...",
  notesLog: "Notizen",
  duplicateWarning: "Mögliches Duplikat: Ein anderes Dokument hat dieselbe Rechnungsreferenz und denselben Versicherungsnehmer.",
  checkingDuplicate: "Duplikate werden geprüft...",
  fieldsNeedAttention: "Felder benötigen Aufmerksamkeit",
  allFieldsComplete: "Alle Felder vollständig",
  vatBreakdown: "MwSt.-Aufschlüsselung",
  vatRate: "MwSt.-Satz",
  netAmount: "Netto",
  vatAmount: "MwSt.",
  grossAmount: "Brutto",
  totalsMatch: "Berechnete Summe stimmt mit dem Rechnungstotal überein",
  totalsDelta: "Differenz zum Rechnungstotal",
  undoMyEdits: "Meine Änderungen verwerfen",
  restoreOriginal: "Originalextraktion wiederherstellen",
  undoMyEditsContent: "Alle ungespeicherten Änderungen an diesem Dokument verwerfen?",
  restoreOriginalContent: "Die Originalextraktion vom Server wiederherstellen? Alle Ihre Änderungen gehen verloren.",
  moveToTreatment: "In Behandlung verschieben",
  duplicateItem: "Position duplizieren",
  moveUp: "Nach oben",
  moveDown: "Nach unten",
  quantityTimesPrice: "Menge × Preis",
  fullscreen: "Vollbild",
  exitFullscreen: "Vollbild beenden",
  thumbnails: "Miniaturen",
  pageOf: "von",
  invalidPostalCode: "Gültige Postleitzahl eingeben (4 Ziffern)",
  overrideAuto: "Automatisch berechneten Wert durch manuelle Eingabe überschreiben",
  discountAppliedAfterSubtotal: "Wird nach der Zwischensumme angewendet",
  verificationCompare: "Prüfung: bisherige Summe {{legacy}} vs. mengenbasierte Summe {{quantityAware}}",
  jumpToNextAttention: "Zum nächsten Feld springen, das Aufmerksamkeit erfordert (Alt+N)",
  moreActions: "Weitere Aktionen"
};

const commonEvents = {
  add: "Hinzufügen",
  update: "Aktualisieren",
  save: "Speichern",
  cancel: "Abbrechen",
  reset: "Zurücksetzen",
  download: "Herunterladen",
  clear: "Entfernen",
  delete: "Löschen",
  assign: "Zuweisen",
  resetInitial: "Ursprungszustand wiederherstellen",
  back: "Zurück",
  assignment_confirmation: "Zuweisung bestätigen",
  enter_notes: "Geben Sie hier Ihre Notizen ein...",
  Updated : "Aktualisiert",
  Exported : "Exportiert",
  Revoked: "Widerrufen",
  Assigned: "Zugewiesen",
  medicineDescription: "Medikamentenbeschreibung",
  purpose: "Zweck",
  usedFor: "Verwendung",
  petTypes: "Tierarten",
  activeIngredients: "Aktive Inhaltsstoffe",
  category: "Kategorie",
  aiCategory: "KI-Kategorie",
  exclusionSubcode: "Ausschluss-Untercode",
  reasoning: "Begründung der Kategorie",
  detection_keywords: "Erkannte Schlüsselwörter",
  translateReasonings: "Kategoriebegründungen übersetzen",
  translateReasoningsSuccess: "Kategoriebegründungen übersetzt",
  translateReasoningsEmpty: "Keine Kategoriebegründungen zum Übersetzen",
  translateReasoningsTo: "Übersetzen nach {{language}}",
  unclassified: "Nicht klassifiziert",
  reasonForChange: "Grund fuer die Aenderung",
  reasonForChangePlaceholder: "Grund auswaehlen",
  changeContext: "Zusaetzlicher Kontext",
  changeContextPlaceholder: "Mehr Details zur aktualisierten Klassifizierung eingeben",
  showMore: "Mehr anzeigen",
  showLess: "Weniger anzeigen",
  typeOfDamage: "Art des Schadens",
  causeOfDamage: "Schadensursache",
  loading: "Laden...",
  confidenceHigh: "Hohe Konfidenz",
  confidenceMedium: "Mittlere Konfidenz",
  confidenceLow: "Niedrige Konfidenz",
  feedbackReasonDiagnosis: "Diagnose",
  feedbackReasonTreatmentContext: "Behandlungskontext",
  feedbackReasonItemTextOrOcr: "Artikeltext oder OCR",
  feedbackReasonExclusionRule: "Ausschlussregel",
  feedbackReasonInvoiceContext: "Rechnungskontext",
  feedbackReasonDuplicateOrWrongLine: "Doppelte oder falsche Zeile",
  feedbackReasonExpertJudgment: "Expertenurteil",
  feedbackReasonOther: "Sonstiges",
  required: "erforderlich",
  feedbackOriginal: "Ursprüngliche KI-Klassifizierung",
  feedbackCorrected: "Korrigierte Klassifizierung",
  feedbackStatusDraft: "Ungespeicherte Klassifizierungskorrektur",
  feedbackStatusPending: "Klassifizierungsfeedback wird gespeichert…",
  feedbackStatusSaved: "Klassifizierungsfeedback gespeichert",
  feedbackStatusError: "Klassifizierungsfeedback fehlgeschlagen",
  feedbackValidationTitle: "Klassifizierungsfeedback erfordert Aufmerksamkeit",
  feedbackValidationDescription: "Korrigieren Sie die markierten Felder vor dem Speichern.",
  feedbackReasonRequired: "Wählen Sie einen Grund für diese Korrektur.",
  feedbackContextRequired: "Geben Sie Kontext an, wenn der Grund Sonstiges ist.",
  feedbackContextTooLong: "Der Kontext darf höchstens {{max}} Zeichen lang sein.",
  feedbackExclusionSubcodeRequired: "Wählen Sie einen gültigen Ausschluss-Untercode.",
  feedbackNonExclusionSubcode: "Ausschluss-Untercodes sind nur für Kategorie E gültig.",
  invalidCategory: "Wählen Sie eine gültige Kategorie.",
  feedbackSaveFailed: "Klassifizierungsfeedback wurde nicht gespeichert",
  feedbackConflict: "Diese Korrektur wurde bereits gesendet oder steht im Konflikt mit einer neueren Korrektur.",
  feedbackStale: "Die KI-Vorhersage hat sich geändert. Laden Sie das Dokument neu.",
  feedbackNetworkError: "Die Korrektur konnte nicht gespeichert werden. Ihr Entwurf bleibt erhalten.",
  feedbackUnavailableLegacy: "Diese KI-Kategorie kann nicht korrigiert werden, weil sie nicht für das Lernen gespeichert wurde. Laden Sie das Dokument neu oder verarbeiten Sie es erneut, wenn es gesperrt bleibt.",
  feedbackUnavailableRetrying: "Die KI-Kategorie wird noch gespeichert. Laden Sie das Dokument in wenigen Minuten neu, um sie zu korrigieren.",
  feedbackUnavailableNotStored: "Diese KI-Kategorie kann nicht korrigiert werden, weil sie nicht im Lernprotokoll gespeichert wurde. Verarbeiten Sie das Dokument erneut.",
  feedbackUnavailableDisabled: "Korrekturen sind in dieser Umgebung nicht aktiv. Die Kategorie bleibt sichtbar, kann aber nicht gespeichert werden.",
  feedbackIdentityRequired: "Diese Korrektur kann nicht gespeichert werden, da die Artikel- oder KI-Vorhersage-ID fehlt. Laden oder verarbeiten Sie das Dokument erneut.",
  feedbackDuplicateItemId: "Dieses Dokument enthält dieselbe Artikel-ID mehrfach. Das Speichern ist blockiert; laden oder verarbeiten Sie das Dokument erneut.",
  cat_T: "Medizinische Behandlung",
  cat_D: "Tod / Invalidität",
  cat_QS: "Vorsorgeuntersuchung",
  cat_QP: "Prophylaxe",
  cat_C: "Komplementärtherapie",
  cat_V: "Impfung",
  cat_Dx: "Erweiterte Diagnostik",
  cat_G: "Diätfutter",
  cat_H: "Therapiesitzungen",
  cat_J: "Verhaltenstherapie",
  cat_W: "Hospitalisierung",
  cat_X: "Einbehaltener Bonus",
  cat_S: "Rettungsdienste",
  cat_A: "Direktzahlung",
  cat_R: "Tierarztberichte",
  cat_E: "Ausschluss",
  exc_g: "Transportkosten",
  exc_x: "Verwaltungsgebühren",
  exc_z: "MwSt.",
  exc_p: "Passuntersuchungen",
  exc_q: "Elektronische Chipkosten",
  exc_i: "Kremierung / Einäscherung",
  exc_b: "Hufbeschlag",
  exc_s: "Elektive Sterilisation",
  exc_c: "Pensionskosten",
  exc_m: "Nicht-medizinische Pflege",
  exc_d: "Zahnbehandlungsausschluss",
  exc_r: "Tierarztberichtskosten",
  operatorFallback: "Calingo-Bearbeiter"
};

const documentStatus = {
  not_yet_started: "Nicht begonnen",
  in_progress: "In Bearbeitung",
  completed: "Abgeschlossen",
};

const confirmationMessages = {
  deleteConfirmationTitle: "Bestätigung",
  deleteActionTreatmentContent:
    "Sind Sie sicher, dass Sie diese Behandlung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden",
  deleteActionItemContent:
    "Sind Sie sicher, dass Sie diese Position löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden",
  resetConfirmationTitle: "Bestätigung",
  resetToInitialConfirmationTitle: "Zurücksetzen auf Erstbestätigung",
  resetActionContent:
    "Sind Sie sicher, dass Sie einen Reset durchführen möchten? Diese Aktion kann nicht rückgängig gemacht werden",
  resetInitialActionContent:
    "Sind Sie sicher, dass Sie auf den Anfangszustand zurücksetzen möchten? Diese Aktion kann nicht rückgängig gemacht werden",
  assignmentConfirmation:
    "Sind Sie sicher, dass Sie dieses Dokument sich selbst zuweisen möchten?",
  revokeConfirmation: "Sind Sie sicher, dass Sie die Zuweisung dieses Dokuments zu Ihrer Person aufheben möchten?",
  reAssignConfirmation:
    "Sind Sie sicher, dass Sie dieses Dokument erneut sich selbst zuweisen möchten?",
  assignedTo: "Dieses Dokument ist zugewiesen an",
};

const errorNotification = {
  invalidEmail: "Bitte geben Sie eine gültige E-Mail Adresse ein!",
  emailEmpty: "Bitte geben Sie Ihre E-Mail Adresse ein!",
  passwordEmpty: "Bitte geben Sie Ihr Passwort ein!",
  notAllowedToEdit: "Dieses Dokument darf nicht bearbeitet werden",
  noteNotSaved: "Notizen werden nicht gespeichert",
  tokenExpired: "Ihre Sitzung ist abgelaufen, bitte melden Sie sich an",
  accessDenied: "Zugriff verweigert",
  notAssigned: "Bitte weisen Sie sich das Dokument zu, um Zugriff zu erhalten",
  documentListError: "Die Dokumentenliste konnte nicht geladen werden",
  genericError: "Etwas ist schiefgelaufen",
};

const successNotification = {
  DocumentResetToInitial: "Das Dokument wurde in den Ursprungszustand zurückgesetzt",
  UpdateSuccess: "Erfolgreich aktualisiert",
  noteSaved: "Notizen wurden erfolgreich gespeichert",
  successDocumentProgressStatus: "Zuweisung erfolgt",
  revokeDocument: "Zuweisung aufgehoben",
}
const batch1Ux = {
  saveAndNext: "Speichern & weiter",
  complete: "Abschliessen",
  completeAndDownload: "Abschliessen & herunterladen",
  completeConfirmTitle: "Dokument abschliessen",
  completeConfirmContent: "Das Dokument wird als abgeschlossen markiert. Fortfahren?",
  startProcessing: "Bearbeitung starten",
  takeOver: "Übernehmen",
  readOnlyAssignedTo: "Schreibgeschützt — dieses Dokument ist {{name}} zugewiesen",
  readOnlyNotAssigned: "Dieses Dokument ist noch nicht zugewiesen — weisen Sie es sich zu, um zu starten",
  savedAt: "Gespeichert {{time}}",
  unsavedChanges: "Ungespeicherte Änderungen",
  unsavedChangesTitle: "Ungespeicherte Änderungen",
  unsavedChangesContent: "Sie haben ungespeicherte Korrekturen. Ohne Speichern verlassen?",
  restore: "Wiederherstellen",
  discard: "Verwerfen",
  restoreDraftTitle: "Ungespeicherten Entwurf wiederherstellen?",
  restoreDraftContent: "Für dieses Dokument wurde ein lokal gespeicherter Entwurf Ihrer Korrekturen gefunden.",
  leave: "Verlassen",
  stay: "Bleiben",
  queueEmpty: "Warteschlange ist leer — keine weiteren Rechnungen zu bearbeiten",
  markedCompleted: "Dokument als abgeschlossen markiert",
  moreActions: "Mehr",
  lastUpdated: "Zuletzt aktualisiert {{time}}",
  mine: "meine",
  failed: "Fehlgeschlagen",
  completedToday: "Heute abgeschlossen",
  clearAllFilters: "Alle Filter löschen",
  selectedCount: "{{count}} ausgewählt",
  assignToMe: "Mir zuweisen",
  markCompleted: "Abschliessen",
  exportSelected: "Auswahl exportieren",
  bulkAssignDone: "{{count}} Ihnen zugewiesen, {{skipped}} übersprungen",
  bulkCompleteDone: "{{completed}} abgeschlossen, {{skipped}} übersprungen",
  bulkExportDone: "{{count}} Dokumente heruntergeladen",
  notAllowedToEditReason: "Das Dokument konnte nicht extrahiert werden (ungültige Datei oder unlesbarer Inhalt), daher gibt es nichts zu korrigieren.",
  totalsMatch: "Berechnet CHF {{calculated}} stimmt mit Rechnungstotal CHF {{total}} überein",
  totalsDelta: "Berechnet CHF {{calculated}} · Rechnungstotal CHF {{total}} · Differenz CHF {{diff}}",
  previewDocument: "Dokumentvorschau",
  previewNotAvailable: "Für dieses Dokument ist keine Vorschau verfügbar.",
  openedAt: "Zuletzt geöffnet {{time}}",
  recentlyModified: "Zuletzt bearbeitet",
  recentlyOpened: "Zuletzt geöffnet",
  recentlyExtracted: "Zuletzt extrahiert",
  noRecentDocuments: "Keine aktuellen Dokumente",
  chooseAvatar: "Tier-Avatar wählen",
  chooseAvatarHint: "Wähle ein Tier. Jedes Tier kann nur von einem Benutzer verwendet werden.",
  avatarLoadError: "Tier-Avatare konnten nicht geladen werden",
  avatarSaveSuccess: "Tier-Avatar gespeichert",
  avatarSaveError: "Tier-Avatar konnte nicht gespeichert werden",
  avatarTaken: "Dieses Tier ist bereits vergeben",
  avatarTakenBy: "Vergeben an {{name}}",
  animalAvatar_dog: "Hund",
  animalAvatar_cat: "Katze",
  animalAvatar_fox: "Fuchs",
  animalAvatar_owl: "Eule",
  animalAvatar_bear: "Bär",
  animalAvatar_rabbit: "Hase",
  animalAvatar_panda: "Panda",
  animalAvatar_lion: "Löwe",
  animalAvatar_tiger: "Tiger",
  animalAvatar_wolf: "Wolf",
  animalAvatar_deer: "Hirsch",
  animalAvatar_hedgehog: "Igel",
  animalAvatar_koala: "Koala",
  animalAvatar_penguin: "Pinguin",
  animalAvatar_otter: "Otter",
  animalAvatar_squirrel: "Eichhörnchen",
  animalAvatar_eagle: "Adler",
  animalAvatar_dolphin: "Delfin",
  animalAvatar_horse: "Pferd",
  animalAvatar_frog: "Frosch",
  reSubmitted: "Erneut eingereicht",
  uploadInvoice: "Rechnung hochladen",
  invoiceFile: "Rechnungsdatei",
  selectInvoiceFile: "Rechnung auswählen oder hierher ziehen",
  supportedInvoiceFiles: "JPG, JPEG, PNG, PDF oder HEIC · max. 14 MiB",
  inboxType: "Postfachtyp",
  description: "Beschreibung",
  invoiceFileRequired: "Eine Rechnungsdatei auswählen",
  invoiceFileTypeError: "JPG-, JPEG-, PNG-, PDF- oder HEIC-Datei verwenden",
  invoiceFileSizeError: "Die Datei darf höchstens 14 MiB gross sein",
  invoiceUploadSuccess: "Rechnung hochgeladen",
  invoiceUploadError: "Rechnung konnte nicht hochgeladen werden",
};

const authManagement = {
  inviteOnlySignup: "Konten sind nur per Einladung verfügbar.",
  invalidInvitation: "Diese Einladung ist ungültig, abgelaufen oder bereits verwendet.",
  acceptInvitation: "Einladung annehmen",
  name: "Name",
  confirmPassword: "Passwort bestätigen",
  passwordsDoNotMatch: "Die Passwörter stimmen nicht überein",
  invitationAccepted: "Einladung angenommen. Melden Sie sich zur MFA-Einrichtung an.",
  backToLogin: "Zurück zur Anmeldung",
  forgotPasswordInstructions: "Geben Sie Ihre E-Mail-Adresse ein, um einen Code zu erhalten.",
  passwordResetEmailSent: "Falls das Konto existiert, wurde ein Code gesendet.",
  sendCode: "Code senden",
  verifyCode: "Code prüfen",
  invalidOrExpiredCode: "Der Code ist ungültig oder abgelaufen.",
  resendUnavailable: "Ein neuer Code kann noch nicht gesendet werden.",
  resetPassword: "Passwort zurücksetzen",
  invalidResetLink: "Die Zurücksetzung ist ungültig oder abgelaufen.",
  passwordPolicy: "Mindestens 12 Zeichen mit Gross-, Kleinbuchstaben, Zahl und Sonderzeichen.",
  passwordResetComplete: "Passwort wurde zurückgesetzt.",
  mfaRecovery: "MFA-Wiederherstellung",
  recoveryCodeSent: "Ein Wiederherstellungscode wurde an {{email}} gesendet.",
  recoveryMustStartAtLogin: "Starten Sie die Wiederherstellung im MFA-Anmeldefenster.",
  waitingForAdminApproval: "E-Mail bestätigt. Administratorfreigabe ausstehend.",
  refreshStatus: "Status aktualisieren",
  recoveryRejected: "Die Wiederherstellung wurde abgelehnt.",
  setupNewAuthenticator: "Neuen Authenticator einrichten",
  usersAndInvitations: "Benutzer & Einladungen",
  inviteUser: "Benutzer einladen",
  inviteLanguage: "Einladungssprache",
  inviteLanguageHint: "Sprache der Einladungs-E-Mail.",
  langGerman: "Deutsch",
  langEnglish: "Englisch",
  langFrench: "Französisch",
  langItalian: "Italienisch",
  used: "Verwendete Lizenzen",
  licensed: "Lizenzierte Benutzer",
  available: "Verfügbare Lizenzen",
  users: "Benutzer",
  invitations: "Einladungen",
  role: "Rolle",
  status: "Status",
  actions: "Aktionen",
  promote: "Zum Admin machen",
  demote: "Adminrolle entfernen",
  activate: "Aktivieren",
  deactivate: "Deaktivieren",
  deliveryStatus: "Zustellung",
  expiresAt: "Läuft ab",
  requestedAt: "Angefordert",
  resend: "Erneut senden",
  revoke: "Widerrufen",
  resendInvitation: "Einladung erneut senden",
  revokeInvitation: "Einladung widerrufen",
  approve: "Genehmigen",
  reject: "Ablehnen",
  approveRecovery: "MFA-Wiederherstellung genehmigen",
  rejectRecovery: "MFA-Wiederherstellung ablehnen",
  confirmAdminAction: "Admin-Aktion mit Passwort bestätigen",
  confirmWithPassword: "Ihr Administratorpasswort",
};

export let deJSON = {
  ...commonEvents,
  ...loginComponent,
  ...dashboardComponent,
  ...errorNotification,
  ...commonTranslation,
  ...documentStatus,
  ...confirmationMessages,
  ...successNotification,
  ...batch1Ux,
  ...authManagement
};
